<template>
    <div class="app-header white box-shadow" :class="{ yellow: $IS_DEV }">
        <div class="navbar">
            <router-link to="/orders" class="navbar-brand">
                <span class="m-r primary-color">Marss Filtry</span>
            </router-link>
            <ul class="nav navbar-nav pull-left text-blue-hover primary-color">
                <!-- <li class="nav-item">
        <router-link class="nav-link" to="/orders">
          <span class="nav-text">Zamówienia</span>
        </router-link>
      </li> -->
                <li class="nav-item" v-if="user != null && UserManager.hasPermission('dashboard.view')">
                    <router-link class="nav-link" to="/dashboards">
                        <i class="material-icons md-18 primary-color">assignment</i>
                    </router-link>
                </li>
                <li class="nav-item dropdown dropdown-submenu">
                    <router-link class="nav-link dropdown-toggle" data-toggle="dropdown" to="/orders">
                        <span class="nav-text">Zamówienia</span>
                    </router-link>
                    <ul class="dropdown-menu pull-down text-color" role="menu">
                        <li class="dropdown-item">
                            <router-link to="/production-requests-calendar-v4">Kalendarz produkcjny</router-link>
                        </li>
                        
                        <li class="dropdown-item" v-if="user != null && UserManager.hasPermission('view.customers')">
                            <router-link to="/customers">Kontrahenci</router-link>
                        </li>
                        <li class="dropdown-item"  v-if="user != null && UserManager.hasPermission('view.shipments')">
                            <router-link to="/shipments">Przesyłki</router-link>
                        </li>
                        <li class="dropdown-item">
                            <router-link to="/production-requests">Zlecenia produkcyjne</router-link>
                        </li>
                        <li class="dropdown-item text-muted">
                            <router-link to="/production-soft-deadline-calendar">Kalendarz sprzedażowy</router-link>
                        </li>
                        <li class="dropdown-item text-muted">
                            <router-link to="/production-requests-calendar">Kalendarz produkcjny (stary)</router-link>
                        </li>
                    </ul>
                </li>

                <li class="nav-item" v-if="user != null && UserManager.hasPermission('view.crm')">
                    <router-link class="nav-link" to="/crm/tickets">
                        <span class="nav-text">CRM</span>
                        <span v-if="ticketUrgent > 0" class="label up danger m-l-xs" style="font-size:9px;padding:2px 5px;">{{ ticketUrgent }}</span>
                    </router-link>
                </li>
                <li class="nav-item" v-if="user != null && UserManager.hasPermission('view.settings')">
                    <router-link class="nav-link" to="/settings">
                        <span class="nav-text">Ustawienia</span>
                    </router-link>
                </li>
                <li class="nav-item" v-if="user != null && UserManager.hasPermission('view.production')">
                    <router-link class="nav-link" to="/production">
                        <span class="nav-text">Produkcja</span>
                    </router-link>
                </li>
                <li class="nav-item dropdown dropdown-submenu" v-if="user != null && UserManager.hasPermission('view.iso')">
                    <a class="nav-link dropdown-toggle" data-toggle="dropdown" href="#">
                        <span class="nav-text">ISO</span>
                    </a>
                    <ul class="dropdown-menu pull-down text-color" role="menu">
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.suppliers-ranking')">
                            <router-link to="/iso/suppliers-ranking">Ranking dostawców</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.suppliers-evaluations')">
                            <router-link to="/iso/suppliers-evaluations">Ankiety dostaw</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.measurement-tools')">
                            <router-link to="/iso/measurement-tools">Urządzenia pomiarowe</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.machines')">
                            <router-link to="/production/machines">Maszyny</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.lab-tests')">
                            <router-link to="/iso/lab-tests">Badania laboratoryjne</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.trainings')">
                            <router-link to="/iso/trainings">Szkolenia</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.training-definitions')">
                            <router-link to="/iso/training-definitions">Słownik szkoleń</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.expiring-documents')">
                            <router-link to="/iso/expiring-documents">Wygasające dokumenty</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.complaints')">
                            <router-link to="/iso/complaints">Reklamacje</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.non-conforming-products')">
                            <router-link to="/iso/non-conforming-products">Wyroby niezgodne</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.couriers')">
                            <router-link to="/iso/couriers">Spedycja – kurierzy</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.couriers-evaluations')">
                            <router-link to="/iso/couriers-evaluations">Ankiety kurierów</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.couriers-ranking')">
                            <router-link to="/iso/couriers-ranking">Ranking kurierów</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.risk-assessments')">
                            <router-link to="/iso/risk-assessments">BHP</router-link>
                        </li>
                        <li class="dropdown-item" v-if="UserManager.hasPermission('view.iso.material-certificates')">
                            <router-link to="/iso/material-certificates">Atesty materiałowe</router-link>
                        </li>
                    </ul>
                </li>
                <li class="nav-item" v-if="user != null && UserManager.hasPermission('view.stats')">
                    <router-link class="nav-link" to="/statistics">
                        <span class="nav-text">Statystyki</span>
                    </router-link>
                </li>
                <li class="nav-item" v-if="user != null && UserManager.hasPermission('view.raports')">
                    <router-link class="nav-link" to="/raports">
                        <span class="nav-text">Raporty</span>
                    </router-link>
                </li>
                <li class="nav-item" v-if="user != null && UserManager.hasPermission('view.monitoring')">
                    <router-link class="nav-link" to="/monitoring">
                        <span class="nav-text">Monitoring</span>
                    </router-link>
                </li>
                <li class="nav-item" v-if="user != null && UserManager.hasPermission('view.stock')">
                    <router-link class="nav-link" to="/stock">
                        <span class="nav-text">Magazyn</span>
                    </router-link>
                </li>
                <li class="nav-item" v-if="user != null && UserManager.hasPermission('view.mds')">
                    <router-link class="nav-link" to="/mds">
                        <span class="nav-text">MARSS dostawy</span>
                    </router-link>
                </li>
            </ul>
            <ProfileSettings v-if="user != null" :userInfo="user"/>
        </div>
    </div>
</template>

<script>
import ProfileSettings from './ProfileSettings.vue'
import UserManager from '../../UserManager.js'
import Api from '../../Api.js'

export default {
    name: 'Header',
    components: {
        ProfileSettings
    },
    data: function () {
        return {
            user: UserManager.user,
            UserManager,
            ticketUrgent: 0
        }
    },
    created: function() {
        UserManager.events.on('userReady', () => {
            this.user = UserManager.user;
            this.loadTicketStats();
        });
        this.loadTicketStats();
        this._ticketInterval = setInterval(() => this.loadTicketStats(), 60000);
    },
    beforeDestroy() {
        if (this._ticketInterval) clearInterval(this._ticketInterval);
    },
    methods: {
        async loadTicketStats() {
            try {
                const res = await Api.imap.tickets.stats();
                this.ticketUrgent = res.urgent || 0;
            } catch (e) { /* brak uprawnien lub serwis niedostepny */ }
        }
    }
}
</script>
